import { get, post } from "api/apiBridges/httpBridge";
import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import Button from '@mui/material/Button';
import { 
    Box, Dialog, IconButton, MenuItem, Select, Typography, 
    FormControl, InputLabel 
} from "@mui/material";
import Scrollbars from "rc-scrollbars";
import { useSelector } from "react-redux";
import { loginSelector } from "store/slices/loginSlice";
import CryptoJS from "crypto-js";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Твои компоненты
import { useLocalNotifications } from "components/Events";
import UserAvatar from "./UserAvatar";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import usePreventDoubleClick from "components/AntiDBC";
import { SelectMarketLocal } from 'components/SelectMarket';
import Loading from 'components/Load';
import { colors } from "styles/colors";
import { useNavigate } from "react-router-dom";
import { useDataContextDeal } from "actions/contextDealClient";
import useOn from "components/socketLib/UseOn";


export default function UnityTotal({ ds, info , onClose}) {
    
    /** @type {[Array<any>, Function]} */
    const [products, setProducts] = useState([])
    

    useEffect(() => {
        if (info) {
            setProducts(info.products)
        }
    }, [info]);

    if (!products) return <></>
    return (
        <div style={{width: "98%", margin:"1%", height: "98%", display: 'flex', flexDirection: 'column'}}>
            <div 
                style={{
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                    padding: '20px 24px',
                    width: '100%',
                    height: "15%",
                    marginTop: "2%"
                }}
            >
                <div 
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'stretch',
                        gap: '16px'
                    }}
                >
                    <div 
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography 
                            style={{
                                fontWeight: 'normal',
                                color: 'gray',
                                fontSize: '14pt',
                                marginBottom: '4px'
                            }}
                        >
                            SKU
                        </Typography>
                        <Typography 
                            style={{
                                fontWeight: 'normal',
                                fontSize: '30pt',
                                textAlign: 'right'
                            }}
                        >
                            {products.length}
                        </Typography>
                    </div>

                    {/* Вертикальный разделитель */}
                    <div 
                        style={{
                            width: '1px',
                            backgroundColor: '#ddd',
                            margin: '8px 0'
                        }}
                    />

                    <div 
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        <Typography 
                            style={{
                                fontWeight: 'normal',
                                color: 'gray',
                                fontSize: '14pt',
                                marginBottom: '4px'
                            }}
                        >
                            Количество
                        </Typography>
                        <Typography 
                            style={{
                                fontWeight: 'normal',
                                fontSize: '30pt',
                                textAlign: 'right'
                            }}
                        >
                            {products.reduce((sum, el) => sum + el.count, 0)}
                        </Typography>
                    </div>
                </div>
            </div>
            <div 
                style={{
                    width: '100%',
                    height: "83%",
                    marginTop: "10px"
                }}
            >
                <Scrollbars style={{height: "100%", width: "100%"}}>
                    {products.map((pr) => 
                        <div 
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                margin: "5px 1% 0px 1%", 
                                alignItems: 'center'
                            }}
                        >
                            <div style={{width: "68%",display: 'flex', flexDirection: 'column'}}>
                                <Typography 
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: '14pt',        
                                    }}
                                >
                                    {pr.title}
                                </Typography>
                                <Typography 
                                    style={{
                                        fontWeight: 'normal',
                                        color: 'gray',
                                        fontSize: '12pt',        
                                    }}
                                >
                                    {pr.barcode}
                                </Typography>
                            </div>
                            <Typography 
                                style={{
                                    fontWeight: 'normal',
                                    fontSize: '20pt',
                                    textAlign: 'right',
                                    width: "30%"

                                }}
                            >
                                {pr.count}
                            </Typography>
                        </div>
                    )}
                </Scrollbars>
            </div>
        </div>
    )
}